const AND = ' '
const OR = ','

const match = (token, field) => field == null || field.toLowerCase().includes(token)

const expression = (ands) => ({
    evaluate(...fields) {
        return ands.every((ors) => fields.some((field) => ors.some((or) => match(or, field))))
    },
})

const nonEmpty = (str) => str !== ''

const tokenize = (query) =>
    query
        .split(AND)
        .filter(nonEmpty)
        .map((and) => and.split(OR).filter(nonEmpty))

export const makeSearcher = (query) => expression(tokenize(query))
